import { AutoMatchRowDetails, BulkCapacityMatchJobTable } from '../views/index';
import { BulkCapacityMatchJob } from '../dtos/index';
import { BulkCapacityMatchJobStatus } from '../constants/bulk-capacity-match-job-status';

export const BULK_CAPACITY_MATCH_JOB_TABLE = (
	bulkCapacityMatchJobsList: Array<BulkCapacityMatchJob> = [],
	usersList: Array<any> = []
): Array<BulkCapacityMatchJobTable> => {
	let results: Array<BulkCapacityMatchJobTable> = [];
	try {
		if (bulkCapacityMatchJobsList.length > 0) {
			bulkCapacityMatchJobsList.map((bulkCapacityMatchJob: BulkCapacityMatchJob) => {
				let row = {} as BulkCapacityMatchJobTable;
				// CN-8805: the web-socket push identifies the row it updates by id.
				row.id = bulkCapacityMatchJob.id;
				row.s3FileLocation = bulkCapacityMatchJob.s3FileLocation;
				row.jobStatus = bulkCapacityMatchJob.jobStatus;
				row.rowDescription = [];
				if (bulkCapacityMatchJob?.jobTasks?.length) {
					bulkCapacityMatchJob.jobTasks?.map((job) => {
						let rowDescription = {} as AutoMatchRowDetails;
						rowDescription.created = job.created;
						rowDescription.s3FileLocation = bulkCapacityMatchJob.s3FileLocation;
						rowDescription.taskStatus = job.taskStatus;
						row.rowDescription.push(rowDescription);
					});
					row.tasksCompleted = bulkCapacityMatchJob.jobTasks?.filter((job) => {
						return job.taskStatus == 'COMPLETED';
					}).length;
				}
				row.created = bulkCapacityMatchJob.created;
				if (bulkCapacityMatchJob.userId) {
					row.userId = bulkCapacityMatchJob.userId;
					const user = usersList?.find((user) => user.userId == bulkCapacityMatchJob.userId);
					if (user) {
						row.userName = user?.name;
					}
				}
				if (bulkCapacityMatchJob.stats) {
					row.tasksInserted =
						bulkCapacityMatchJob.stats[bulkCapacityMatchJob.id][
							BulkCapacityMatchJobStatus.COMPLETED
						] || 0;
					row.tasksFailed =
						bulkCapacityMatchJob.stats[bulkCapacityMatchJob.id][
							BulkCapacityMatchJobStatus.FAILED
						] || 0;
					row.totalTasks = row.tasksParsed =
						bulkCapacityMatchJob.stats[bulkCapacityMatchJob.id]['total'] || 0;
				} else {
					row.tasksInserted = row.totalTasks = row.tasksFailed = 0;
				}
				row.lastModified = bulkCapacityMatchJob.lastModified;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('BULK_CAPACITY_MATCH_JOB_TABLE error: ', error);
	}
	return results;
};
